module.exports = __webpack_public_path__ + "media/integrations/woocommerce_right-8f72583c.svg";